import styled from "styled-components";

export const Main = styled.div`
   width: 150px;
   padding: 0;
`;

export const Styled = styled.div`
   position: relative;

   .questionSection {
      margin: 15px 0;
      
      .hint {
         margin-top: 8px;
         font-size: 11px;
         color: #666;
         line-height: 1.4;
      }
   }
   
   .filesEdit {
      top: calc(-100% - 25px) !important;
      right: calc(100% + 52px) !important;
      height: auto !important;
      max-height: 200px;

      &::before {
         top: 18px;
      }
      .checkbox {
         height: auto !important;
         max-height: 186px;
      }
   }
`;